import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, User, ArrowLeft } from 'lucide-react';
import api from '../utils/api';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [slug]);

  const fetchBlog = async () => {
    try {
      const response = await api.get(`/blogs/${slug}`);
      setBlog(response.data);
    } catch (error) {
      console.error('Error fetching blog:', error);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FFFDF9] py-20">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="min-h-screen bg-[#FFFDF9] py-20">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <p className="text-gray-600 mb-4">Blog post not found.</p>
          <Link to="/blogs" className="text-[#E5A93C] hover:underline">← Back to Blogs</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      <div className="container mx-auto px-4 md:px-8 py-12">
        <Link to="/blogs" className="inline-flex items-center text-[#E5A93C] hover:underline mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Blogs
        </Link>

        <article className="max-w-3xl mx-auto">
          {blog.thumbnail && (
            <img
              src={blog.thumbnail}
              alt={blog.title}
              className="w-full h-96 object-cover rounded-sm mb-8"
            />
          )}

          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A0000] mb-4">
            {blog.title}
          </h1>

          <div className="flex items-center space-x-6 text-gray-600 mb-8 pb-8 border-b border-gray-200">
            <span className="flex items-center space-x-2">
              <User className="w-5 h-5" />
              <span>{blog.author}</span>
            </span>
            <span className="flex items-center space-x-2">
              <Calendar className="w-5 h-5" />
              <span>{new Date(blog.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
            </span>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="text-[#2C2C2C] leading-relaxed whitespace-pre-wrap">
              {blog.content}
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogDetailPage;
